export default "__VITE_ASSET__tCLI_agu__"